import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-close',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M5.29289 5.29289c.39053-.39052 1.02369-.39052 1.41422 0L12 10.5858l5.2929-5.29291c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422L13.4142 12l5.2929 5.2929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L12 13.4142l-5.29289 5.2929c-.39053.3905-1.02369.3905-1.41422 0-.39052-.3905-.39052-1.0237 0-1.4142L10.5858 12 5.29289 6.70711c-.39052-.39053-.39052-1.02369 0-1.41422Z"
            clip-rule="evenodd" />
    </svg>
  `
})
export class IconCloseComponent {
  size: InputSignal<number> = input<number>(24);
}
